(function() {
    'use strict';

    var VvSpinner = function($scope) {
        this.getSpinnerUrl = () => {
            var url = null;
            var currentScope = $scope;
            do {
                url = currentScope.srcSpinner;
                currentScope = currentScope.$parent;
            } while (url === undefined && currentScope !== null);
            return url;
        };
    };

    VvSpinner.$inject = ['$scope'];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT + 'components/vvSpinner/vvSpinner.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var VvSpinnerComponent = {
        controller: VvSpinner,
        controllerAs: 'spinner',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomSpinner', VvSpinnerComponent);
})();